package music.jammers.shared.event.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class UserAcceptance(
    val hard: Int,
    val weak: Int,
    val hardLimit: Int,
)